module.exports = __webpack_public_path__ + "static/media/Logo.546f0620.png";